module.exports = __webpack_public_path__ + "img/hr-deepwater1.3bda7a34.png";